import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getReceiptAccountUpdationByApproval = createAsyncThunk(
  "app/getReceiptAccountUpdationByApproval",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc-acct-audit/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const updateReceiptAccountUpdationByApproval = createAsyncThunk(
  "app/updateReceiptAccountUpdationByApproval",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc-acct-audit`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getReceiptAccountUpdationByApprovalReport = createAsyncThunk(
  "app/getReceiptAccountUpdationByApprovalReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-acct-audit/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getDocImage = async (id, name) => {
  try {
    const res = await axios.get(
      `/api/image?profile=request-form&id=${id}&name=${name}`
    );
    return res.data;
  } catch (err) {
    return null;
  }
};
